<template>
  <a-modal
    title="新建"
    style="top: 20px;"
    :width="1400"
    v-model="disible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :footer="null"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form1" @keyup.enter="handleSelect">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item label="企业名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                showSearch
                optionFilterProp="children"
                v-model="queryParam.enterpriseId"
                :filterOption="filterOption"
                allowClear="true"
              >
                <a-select-option v-for="item of data" :key="item.enterpriseId">{{item.enterpriseName}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="配件类型">
              <a-select
                showSearch
                optionFilterProp="children"
                v-model="queryParam.accessoryType"
                :filterOption="filterOption"
                allowClear="true"
              >
                <a-select-option v-for="item of data2" :key="item.accessoryType">{{item.accessoryType}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装类别">
              <a-select  v-model="queryParam.installType" @change="handleChange1" allowClear="true">
                <a-select-option  v-for="type in restaurantTypes" :key="type.code">{{type.label}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="配件名称">
              <a-select
                showSearch
                optionFilterProp="children"
                v-model="queryParam.accessoryName"
                :filterOption="filterOption"
                allowClear="true"
              >
                <a-select-option v-for="item of data3" :key="item.accessoryName">{{item.accessoryName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="可使用品牌">
              <a-select
                showSearch
                optionFilterProp="children"
                v-decorator="['brandId']"
                :filterOption="filterOption"
                allowClear="true"
              >
                <a-select-option v-for="item of data1" :key="item.brandId">{{item.brandName}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="配件型号" style="margin-left: 14px;">
              <a-select
                showSearch
                optionFilterProp="children"
                v-model="queryParam.accessoryCategory"
                :filterOption="filterOption"
                allowClear="true"
              >
                <a-select-option v-for="item of data4" :key="item.accessoryCategory">{{item.accessoryCategory}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="型号" style="margin-left: 28px">
              <a-input v-model="queryParam.modelName" />
            </a-form-item>
            <a-form-item label="配件规格">
              <a-select
                showSearch
                optionFilterProp="children"
                v-model="queryParam.accessorySpecification"
                :filterOption="filterOption"
                allowClear="true"
              >
                <a-select-option v-for="item of data5" :key="item.accessorySpecification">{{item.accessorySpecification}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row style="margin-bottom: 15px">
          <a-col :span="6" :offset="18" style="display: flex;justify-content: flex-end;">
            <a-button type="primary" @click="handleSelect">查询</a-button>
            <a-button style="margin-left: 8px" @click="handleClear">清空</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      size="default"
      ref="table1"
      :columns="columns"
      :data="loadData"
      :scroll="{x:1500}"
      bordered
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handle1(record)">选择</a>
        <!--<a v-if="editEnabel" @click="handleEdit(record)">编辑</a>-->
        <!--<a-divider type="vertical"/>-->
        <!--<a v-if="removeEnable" @click="delByIds([record.accessoryId])">删除</a>-->
      </span>
    </s-table>
    <accessory-modal ref="modal" @haveOk="handleOk"/>
  </a-modal>
</template>

<script>
import { STable } from '@/components'
import { addCommonEnterpriseAccessory,getEnterpriseAccessory, delAccessory,getSlectCombox,getSelectBrand,selectAccessoryTypeCombox,selectAccessoryNameCombox,selectAccessoryCategoryCombox,selectAccessorySpecificationCombox } from '@/api/enterprise/accessory'
import AccessoryModal from './modules/AccessoryModal.vue'
import { checkPermission } from '@/utils/permissions'
import {getDictMap} from "../../utils/dict"

export default {
  name: 'TableList',
  components: {
    STable,
    AccessoryModal
  },
  data () {
    return {
      // size: 'default',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form1: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width:60,
          dataIndex: 'rowNum',
          align:'center'
        },
        {
          title: '操作',
          width:60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align:'center'
        },
        {
          title: '配件类型',
          dataIndex: 'accessoryType',
          align:'center'
        },
        {
          title: '配件名称',
          dataIndex: 'accessoryName',
          align:'center'
        },
        {
          title: '配件型号',
          dataIndex: 'accessoryCategory',
          align:'center'
        },
        {
          title: '配件规格',
          dataIndex: 'accessorySpecification',
          align:'center'
        },
        {
          title: '安装类别',
          dataIndex: 'installName',
        },
        {
          title: '可使用品牌',
          dataIndex: 'brandName',
        },
        {
          title: '可使用型号',
          dataIndex: 'modelName',
        },
        {
          title: '是否通用配件',
          dataIndex: 'commonFlag',
          align:'center'
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getEnterpriseAccessory(Object.assign(parameter, this.queryParam))
      },
      disible:false,
      data:[],
      data1:[],
      data2:[],
      data3:[],
      data4:[],
      data5:[],
      restaurantTypes:[],
      addEnable: checkPermission('stock:accessory:add'),
      editEnabel: checkPermission('stock:accessory:edit'),
      removeEnable: checkPermission('stock:accessory:remove')
    }
  },
  filters: {},
  async created () {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode == 13) {
        this.handleSelect()
      }
    })
    this.restaurantTypes = [];
    this.restaurantOperTypeMap = await getDictMap('install_type');
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes.push({code: key, label: value})
    })
    getSlectCombox().then(res=>{
      // console.log(res.data)
      this.data = res.data
    })
    selectAccessoryTypeCombox().then(res=>{
      // console.log(res.data)
      this.data2 = res.data
    })
    selectAccessoryNameCombox().then(res=>{
      // console.log(res.data)
      this.data3 = res.data
    })
    selectAccessoryCategoryCombox().then(res=>{
      // console.log(res.data)
      this.data4 = res.data
    })
    selectAccessorySpecificationCombox().then(res=>{
      // console.log(res.data)
      this.data5 = res.data
    })
  },

  methods: {
    handleSelect(){
      this.queryParam.brandId=this.form1.getFieldValue('brandId')
      this.$refs.table1.refresh(true)
    },
    handleClear() {
      this.queryParam = {}
      this.data1 = []
      this.form1.resetFields()
    },
    handleChange1 (value) {
      // console.log(`selected ${value}`)
      this.form1.setFieldsValue({
        'brandId':undefined,
      })
      this.data1 = []
      if(value != undefined){
        getSelectBrand({installType:value}).then(res=>{
          // console.log(res.data)
          this.data1 = res.data
        })
      }
    },
    // 选择
    handle1(record){
      // console.log(record)
      if(record.commonFlag == '是'){
        addCommonEnterpriseAccessory({accessoryId:record.accessoryId,enterpriseId:record.enterpriseId}).then(res=>{
          console.log(res.code)
          this.$emit('ok')
          this.disible = false
        })
      }else if(record.commonFlag == '否'){
        this.$refs.modal.handleDelay(record)
      }
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    add(){
      this.form1.resetFields()
      this.disible = true
      this.$refs.table1.refresh(true)
    },
    handleOk () {
      this.$emit('ok')
      this.disible = false
      this.$refs.table1.refresh(true)
      console.log('handleSaveOk')
    },
  },
  watch: {
    /*
          'selectedRows': function (selectedRows) {
            this.needTotalList = this.needTotalList.map(item => {
              return {
                ...item,
                total: selectedRows.reduce( (sum, val) => {
                  return sum + val[item.dataIndex]
                }, 0)
              }
            })
          }
          */
  }
}
</script>
<style scoped>
  .twobtn{
    background-color: #169BD5;
    color: white;
    width: 110px;
    font-size: 15px;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap;padding: 4px 16px !important;}
</style>
